import React from "react";
import NoStagingLocationBanner from "./NoStagingLocationBanner";

const OutboundBanners = () => {
    return <div>
        <NoStagingLocationBanner />
    </div>;
}

export default OutboundBanners;



// WEBPACK FOOTER //
// ./src/components/outboundBanners/index.js